import * as H from 'history';
import  React from 'react';
import { Route, Switch } from 'react-router';
import { ClaimController } from '../../controllers/ClaimController';
import { ClaimModel } from '../../models/ClaimModel';
import { Consultant } from '../../models/Consultant';
import { ISupportSpinner } from '../../shared/Ajax';
import { Backdrop } from '../../shared/Backdrop';
import { Option } from '../../shared/fields/Options';
import { TimeoutPopup } from '../../shared/TimeoutPopup';
import { BusinessPage } from './BusinessPage';
import { documentTypeInfo } from './documents/DocumentTypeInfo';
import { ApplicationForm1DocumentUploadPage } from './documents/DocumentUploadPage';
import { FinancialAssistancePage } from './otherTables/financialAssistance/FinancialAssistancePage';
import { RelationshipPage } from './otherTables/relationships/RelationshipPage';
import { StakeholderPage } from './otherTables/stakeholders/StakeholderPage';
import { PersonalisePage } from './PersonalisePage';
import { PreparePage } from './PreparePage';
import { ApplicationForm1PreviewPage } from './PreviewPage';
import { ReviewPage } from './ReviewPage';
import { EventPromotersPage } from './schedules/Earnings/EventPromotersPage';
import { GoodsPage } from './schedules/Earnings/GoodsPage';
import { RelatedEntitiesPage } from './schedules/Earnings/RelatedEntitiesPage';
import { ServicesIPRKnowHowPage } from './schedules/Earnings/ServicesIPRKnowHowPage';
import { TourismServicesPage } from './schedules/Earnings/TourismServicesPage';
import { AdvertisingPage } from './schedules/Expenses/AdvertisingPage';
import { FreeSamplesPage } from './schedules/Expenses/FreeSamplesPage';
import { IntellectualPropertyInsurancePage } from './schedules/Expenses/IntellectualPropertyInsurancePage';
import { IntellectualPropertyRegistrationPage } from './schedules/Expenses/IntellectualPropertyRegistrationPage';
import { MarketingConsultantPage } from './schedules/Expenses/MarketingConsultantPage';
import { MarketingVisitPage } from './schedules/Expenses/MarketingVisitPage';
import { OverseasBuyersPage } from './schedules/Expenses/OverseasBuyersPage';
import { PromotionalEventsPage } from './schedules/Expenses/PromotionalEventsPage';
import { RepresentationPage } from './schedules/Expenses/RepresentationPage';
import { TermsPage } from './TermsPage';
import { MarketSharePage } from './otherTables/marketShare/MarketSharePage';
import { ApplicationForm1SubmissionPage } from './SubmissionPage';

export interface ApplicationForm1Props {
    history: H.History
    location: H.Location
    claimId: string
}

export interface ApplicationForm1State {
    loading: boolean
    readOnly: boolean
    model: ClaimModel
    autoClaimNumber: string
    markets: Option<string>[]
    addressCountries: Option<string>[]
    lowRiskMarkets: string[]
    consultants: Consultant[]
    pdfContect: boolean
    autoLogout: boolean
}

interface Tab {
    link: string,
    text: string
}

const applicationForm1Tabs: Tab[] = [
    {
        link: 'terms',
        text: 'Terms & conditions'
    },
    {
        link: 'business',
        text: 'Business details'
    },
    {
        link: 'personalise',
        text: 'Personalise claim'
    },
    {
        link: 'prepare',
        text: 'Prepare claim'
    }
];

export class ApplicationForm1 extends React.Component<ApplicationForm1Props, ApplicationForm1State> implements ISupportSpinner {
    ajax: ClaimController
    previewForm: HTMLFormElement
    previewInput: HTMLInputElement
    previewContent: HTMLDivElement

    constructor(props: ApplicationForm1Props) {
        super(props);

        this.ajax = new ClaimController();

        this.state = {
            loading: false,
            readOnly: false,
            model: null,
            autoClaimNumber: null,
            markets: [],
            addressCountries: [],
            lowRiskMarkets: [],
            consultants: [],
            pdfContect: false,
            autoLogout: false
        }
    }

    componentDidMount() {
        window.onbeforeunload = () => {
            if (!this.state.autoLogout)
                return "Changes you made may not be saved.";
        }
        this.load();
    }

    componentDidUpdate(prevProps: ApplicationForm1Props, prevState: ApplicationForm1State) {
        if (this.props.claimId != prevProps.claimId || this.state.model && this.state.model.claimId != this.props.claimId) {
            this.load();
        }
        else if (this.props.location.pathname != prevProps.location.pathname && this.props.location.pathname.indexOf('/prepare/documents/') < 0) {
            var lastValidPage = this.state.model.lastValidPage;
            if (this.getTabIndex(this.props.location.pathname) > this.getTabIndex(this.state.model.lastValidPage)) {
                lastValidPage = this.props.location.pathname;
            }
            this.setState({
                model: { ...this.state.model, currentPage: this.props.location.pathname, lastValidPage }
            })
        }
    }

    componentWillUnmount() {
        window.onbeforeunload = null;
        this.ajax.cancel();
    }

    onAutoLogout = () => {
        this.setState({ autoLogout: true });
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }

    getTabIndex = (url: string) => {
        if (url) {
            if (url.indexOf("/review") >= 0)
                return 3;

            for (let i = 0; i < applicationForm1Tabs.length; i++) {
                if (url.indexOf(applicationForm1Tabs[i].link.toLowerCase()) >= 0) {
                    return i;
                }
            }
        }
        return 0;
    }

    getTab = (url: string) => {
        return applicationForm1Tabs[this.getTabIndex(url)];
    }

    load = () => {
        this.ajax.getItem(this, this.props.claimId, payload => {
            this.setState(payload, () => {
                if (!this.state.readOnly) {
                    var tab = this.getTab(payload.model.currentPage);
                    this.props.history.replace(`/claim/${this.props.claimId}/${tab.link}`);
                }
                else {
                    this.props.history.replace(`/claim/${this.props.claimId}/preview`);
                }
            });
        });
    }

    navigate = (tabIndex: number) => {
        let lastValidTabIndex = this.getTabIndex(this.state.model.lastValidPage);
        if (tabIndex > lastValidTabIndex) {
            alert("Please use 'Save & Next' button to navigate to the tab");
            return;
        }
        this.props.history.push(`/claim/${this.props.claimId}/${applicationForm1Tabs[tabIndex].link}`);
    }

    saveAndExit = (e: React.MouseEvent) => {
        e.preventDefault();
        this.ajax.updateClaim(this, this.state.model, () => {
            this.props.history.push(`/dashboard-forms`);
        });
    }

    save = (e: React.MouseEvent) => {
        e.preventDefault();
        this.ajax.updateClaim(this, this.state.model, () => { });
    }

    preview = (e: React.MouseEvent) => {
        e.preventDefault();
        this.setState({ pdfContect: true }, () => {
            this.previewInput.value = this.previewContent.innerHTML;
            this.previewForm.submit();
            this.setState({ pdfContect: false })
        });
    }

    print = (e: React.MouseEvent) => {
        e.preventDefault();
        this.props.history.push(`/claim/${this.props.claimId}/preview/print`);
    }

    onChange = (changes: Partial<ClaimModel>, callback?: { (): any }) => {
        this.setState({ model: { ...this.state.model, ...changes, lastValidPage: this.props.location.pathname } }, callback);
    }

    onSubmit = (autoClaimNumber: string, callback?: { (): any }) => {
        this.setState({ autoClaimNumber: autoClaimNumber }, callback);
    }

    render() {
        if (!this.state.model || this.state.model.claimId != this.props.claimId) {
            return <div className="container-fluid mt-2 text-center"><h5>Please wait. Loading...</h5></div>
        }

        let routes = <Switch>
            <Route path="/claim/:id/terms" render={p => <TermsPage model={this.state.model} onChange={this.onChange} history={p.history} />} />
            <Route path="/claim/:id/business" render={p => <BusinessPage model={this.state.model} onChange={this.onChange} history={p.history} addressCountries={this.state.addressCountries} />} />
            <Route path="/claim/:id/personalise" render={p => <PersonalisePage model={this.state.model} onChange={this.onChange} history={p.history} consultants={this.state.consultants} addressCountries={this.state.addressCountries} />} />
            <Route path="/claim/:id/prepare" exact render={p => <PreparePage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} addressCountries={this.state.addressCountries} lowRiskMarkets={this.state.lowRiskMarkets} />} />
            <Route path="/claim/:id/prepare/stakeholders" render={p => <StakeholderPage model={this.state.model} onChange={this.onChange} history={p.history} />} />
            <Route path="/claim/:id/prepare/financialassistance" render={p => <FinancialAssistancePage model={this.state.model} onChange={this.onChange} history={p.history} />} />
            <Route path="/claim/:id/prepare/relationships" render={p => <RelationshipPage model={this.state.model} onChange={this.onChange} history={p.history} addressCountries={this.state.addressCountries} />} />
            <Route path="/claim/:id/prepare/marketshare" render={p => <MarketSharePage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />

            <Route path="/claim/:id/prepare/representation/:item?" render={p => <RepresentationPage model={this.state.model} item={p.match.params.item} onChange={this.onChange} history={p.history} markets={this.state.markets} addressCountries={this.state.addressCountries} />} />
            <Route path="/claim/:id/prepare/marketingconsultants/:item?" render={p => <MarketingConsultantPage model={this.state.model} item={p.match.params.item} onChange={this.onChange} history={p.history} markets={this.state.markets} addressCountries={this.state.addressCountries} />} />
            <Route path="/claim/:id/prepare/marketingvisits" render={p => <MarketingVisitPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/freesamples" render={p => <FreeSamplesPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/promotionalevents" render={p => <PromotionalEventsPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/advertising" render={p => <AdvertisingPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/overseasbuyers" render={p => <OverseasBuyersPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/intellectualpropertyregistration" render={p => <IntellectualPropertyRegistrationPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/intellectualpropertyinsurance" render={p => <IntellectualPropertyInsurancePage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />

            <Route path="/claim/:id/prepare/goods" render={p => <GoodsPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/servicesiprknowhow" render={p => <ServicesIPRKnowHowPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/tourismservices" render={p => <TourismServicesPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/eventpromoters" render={p => <EventPromotersPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />
            <Route path="/claim/:id/prepare/relatedentities" render={p => <RelatedEntitiesPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} />} />

            <Route path="/claim/:id/review" render={p => <ReviewPage model={this.state.model} onChange={this.onChange} onSubmit={this.onSubmit} history={p.history} consultants={this.state.consultants} markets={this.state.markets} addressCountries={this.state.addressCountries} lowRiskMarkets={this.state.lowRiskMarkets} />} />
            <Route path="/claim/:id/submission" render={p => <ApplicationForm1SubmissionPage model={this.state.model} history={p.history} autoClaimNumber={this.state.autoClaimNumber} onPrint={this.preview} />} />

            <Route path="/claim/:id/preview" exact render={p => <ApplicationForm1PreviewPage model={this.state.model} onChange={this.onChange} onSubmit={this.onSubmit} history={p.history} markets={this.state.markets} consultants={this.state.consultants} addressCountries={this.state.addressCountries} lowRiskMarkets={this.state.lowRiskMarkets} onPrint={this.preview} />} />
            <Route path="/claim/:id/preview/print" render={p => <ApplicationForm1PreviewPage model={this.state.model} onChange={this.onChange} onSubmit={this.onSubmit} history={p.history} print={true} markets={this.state.markets} consultants={this.state.consultants} addressCountries={this.state.addressCountries} lowRiskMarkets={this.state.lowRiskMarkets} />} />
            <Route path="/claim/:id/prepare/documents/:code/:item?" render={p => <ApplicationForm1DocumentUploadPage model={this.state.model} code={p.match.params.code} item={p.match.params.item || ""} onChange={this.onChange} history={p.history} />} />
        </Switch>;

        if (this.state.readOnly) {
            routes = <Switch>
                <Route path="/claim/:id/preview" exact render={p => <ApplicationForm1PreviewPage model={this.state.model} onChange={this.onChange} onSubmit={this.onSubmit} history={p.history} markets={this.state.markets} consultants={this.state.consultants} addressCountries={this.state.addressCountries} lowRiskMarkets={this.state.lowRiskMarkets} onPrint={this.preview} />} />
            </Switch>;
        }

        let pdfContent = this.state.pdfContect ?
            <>
                <div ref={r => this.previewContent = r}>
                    <ApplicationForm1PreviewPage model={this.state.model} onChange={this.onChange} onSubmit={this.onSubmit} history={this.props.history} markets={this.state.markets} consultants={this.state.consultants} addressCountries={this.state.addressCountries} lowRiskMarkets={this.state.lowRiskMarkets} />
                </div>
                <form ref={r => this.previewForm = r} action="/api/pdf" target="_blank" method="POST" style={{ display: "none" }}>
                    <input type="hidden" name="content" ref={r => this.previewInput = r} />
                    <input type="hidden" name="orgName" value={this.state.model.registeredNameLocal || this.state.model.registeredName} />
                </form>
            </>
            : <></>;

        let preparePart = this.props.location.pathname.indexOf('/prepare');
        let reviewPage = this.props.location.pathname.indexOf('/review') >= 0;
        let submissionPage = this.props.location.pathname.indexOf('/submission') >= 0;
        let previewPage = this.props.location.pathname.indexOf('/preview') >= 0

        let prepareSection = (preparePart >= 0 && this.props.location.pathname.substr(preparePart + '/prepare'.length).replace(/\/$/, '') ? true : false);
        if (prepareSection || previewPage || submissionPage) {
            return <div className="container-fluid mt-2">
                <div className="row">
                    <div className="col-lg-9">
                        {routes}
                    </div>
                </div>
                {pdfContent}
                <TimeoutPopup onLogout={this.onAutoLogout} />
            </div>
        }

        let documents: JSX.Element[] = [];

        if (reviewPage) {
            //Do nothing
        }
        else if (preparePart < 0) {
            for (let docType of documentTypeInfo) {
                var items = docType.reducer(this.state.model, this.state.lowRiskMarkets);
                for (let id of items) {
                    if (docType.quickList(this.state.model, id)) {
                        let className = "todo";
                        if (this.state.model.documents.filter(r => r.code == docType.code && r.itemId == id).length > 0) {
                            className = "done"
                        }
                        documents.push(<li key={`${docType.code}-${id}`}>
                            <a className={className} href="#" onClick={e => { e.preventDefault(); this.props.history.push(`/claim/${this.state.model.claimId}/prepare/documents/${docType.code}/${id}`) }}>
                                {docType.title(this.state.model, id)}
                            </a>
                        </li>);
                    }
                }
            }
        }
        else {
            documents.push(<li key={`more`}>
                <a href="#supportingDocumentSection">
                    See below...
                </a>
            </li>);
        }

        let currentTabIndex = this.getTabIndex(this.props.location.pathname);
        let lastValidTabIndex = this.getTabIndex(this.state.model.lastValidPage);

        return <div className="container-fluid mt-2 ">
            <div className="row">
                <div className="col-lg-9">
                    {applicationForm1Tabs.filter(d => this.props.location.pathname.toLowerCase().indexOf(d.link.toLowerCase()) >= 0).map((d, i) => {
                        return <div key={i} className="mb-2 aus-tab-header">
                            {d.text}
                        </div>
                    })}
                    <div className="mb-3 aus-tab-container">
                        {applicationForm1Tabs.map((d, i) => {
                            return <div key={i} className={`aus-tab` +
                                `${i == currentTabIndex ? " aus-tab-active" : ""}` +
                                `${i > lastValidTabIndex ? " aus-tab-disabled" : ""}`
                            }>
                                <a id={`tab${d.text}`} className="aus-tab-title" href="#" onClick={e => { this.navigate(i); e.preventDefault(); }}>{d.text}</a>
                                <a id={`tab${i + 1}`} className="aus-tab-number" href="#" onClick={e => { this.navigate(i); e.preventDefault(); }}>{i + 1}</a>
                            </div>
                        })}
                    </div>
                    {routes}
                </div>
                <div className="col-lg-3">
                    <div className="aus-formnav">
                        <div>
                            <ul className="aus-org-name">
                                <li>
                                    <strong>{this.state.model.registeredNameLocal || this.state.model.registeredName}</strong>
                                </li>
                            </ul>
                            <ul className="aus-formnav-actions">
                                <li>
                                    <a href="#" onClick={this.saveAndExit}>
                                        <img src="/images/saveandexit.png" className="mr-2" />
                                        <span className="media-body">Save & Exit</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={this.save}>
                                        <img src="/images/save.png" className="mr-2" />
                                        <span className="media-body">Save</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={this.preview}>
                                        <img src="/images/preview.png" className="mr-2" />
                                        <span className="media-body">Preview & Print</span>
                                    </a>
                                </li>
                            </ul>
                            {documents.length > 0 ? <><h5>Required documents</h5>
                                <ul className="aus-formnav-todo">
                                    {documents}
                                </ul></> : <></>}
                        </div>
                    </div>
                </div>
            </div>
            {pdfContent}
            <Backdrop on={this.state.loading} />
            <TimeoutPopup onLogout={this.onAutoLogout}/>
        </div>
    }
}